import { composePractice, formatDuration, practiceText } from './kg-pratica-engine.js';

const decode = value => {
  if (typeof value === 'string') { const node=document.createElement('textarea'); node.innerHTML=value; return node.value; }
  if (Array.isArray(value)) return value.map(decode);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key,item])=>[key,decode(item)]));
  return value;
};
function init(root) {
  if (root.dataset.kpReady) return;
  let content;
  try { content=decode(JSON.parse(root.querySelector('[data-kp-content]').textContent)); } catch { return; }
  const form=root.querySelector('[data-kp-form]');
  const result=root.querySelector('[data-kp-result]');
  const heading=result.querySelector('[data-kp-title]');
  const status=root.querySelector('[data-kp-status]');
  const feedback=root.querySelector('[data-kp-download-status]');
  const list=result.querySelector('[data-kp-steps]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let practice=null;
  const navigate = (node,focus) => { focus?.focus({preventScroll:true}); node.scrollIntoView({block:'start',behavior:reduced.matches?'auto':'smooth'}); };
  form.addEventListener('submit',event => {
    event.preventDefault();
    const data=new FormData(form);
    try {
      practice=composePractice({minutes:data.get('minutes'),goal:data.get('goal'),materials:data.getAll('materials')},content);
      heading.textContent=practice.title;
      result.querySelector('[data-kp-time]').textContent=formatDuration(practice.totalSeconds,content.ui);
      result.querySelector('[data-kp-material]').textContent=practice.material==='none'?content.ui.no_material:content.materials[practice.material];
      result.querySelector('[data-kp-goal]').textContent=practice.goal;
      list.replaceChildren(...practice.steps.map((step,index)=>{
        const item=document.createElement('li'); item.dataset.seconds=step.seconds;
        const top=document.createElement('div'); top.className='kg-practice__step-head';
        const title=document.createElement('h3'); title.textContent=step.title;
        const duration=document.createElement('span'); duration.className='kg-practice__step-time'; duration.textContent=formatDuration(step.seconds,content.ui);
        const body=document.createElement('p'); body.textContent=step.body;
        top.append(title,duration); item.append(top,body); return item;
      }));
      status.textContent=''; feedback.textContent=''; result.hidden=false;
      root.dataset.kpState='result';
      navigate(result,heading);
    } catch { status.textContent=content.ui.error; }
  });
  form.addEventListener('change',()=>{
    if (!practice) return;
    practice=null; result.hidden=true; feedback.textContent=''; status.textContent=content.ui.changed; root.dataset.kpState='editing';
  });
  root.querySelector('[data-kp-edit]').addEventListener('click',()=>navigate(form,form.querySelector('[name="minutes"]:checked')));
  root.querySelector('[data-kp-download]').addEventListener('click',()=>{
    if (!practice) return;
    const url=URL.createObjectURL(new Blob([practiceText(practice,content)],{type:'text/plain;charset=utf-8'}));
    const link=document.createElement('a'); link.href=url; link.download=content.ui.filename.replace(/\{\{\s*minutes\s*\}\}|§/g,String(practice.options.minutes));
    link.hidden=true; root.append(link); link.click(); link.remove();
    window.setTimeout(()=>URL.revokeObjectURL(url),1000);
    feedback.textContent=content.ui.download_ready;
  });
  form.hidden=false; root.querySelector('[data-kp-fallback]').hidden=true;
  root.querySelector('[data-kp-aside]').hidden=false;
  root.dataset.kpReady='true'; root.dataset.kpState='editing';
}
document.querySelectorAll('[data-kp]').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kp]').forEach(init));
